import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-time-tracking-header-ds',
  imports: [],
  template: `
    <div class="tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-center tw-gap-4">
      <div>
        <div
          class="tw-bg-[var(--sed-purple-40-color)] tw-border tw-w-64 tw-rounded-xl tw-pt-2 tw-pl-6 tw-font-bold"
        >
          <div class="tw-text-xl">Off work</div>
          <div class="tw-py-3">
            <span class="tw-text-[64px] tw-leading-none">{{ offWork }}</span>
            <span
              class="tw-text-md tw-pl-2 tw-text-[var(x--sed-black-60-color)]"
              >days</span
            >
          </div>
        </div>
      </div>
      <div>
        <div
          class="tw-bg-[var(--sed-purple-40-color)] tw-border tw-w-64 tw-rounded-xl tw-pt-2 tw-pl-6 tw-font-bold"
        >
          <div class="tw-text-xl">Restricted duty</div>
          <div class="tw-py-3">
            <span class="tw-text-[64px] tw-leading-none">{{
              restricted
            }}</span>
            <span
              class="tw-text-md tw-pl-2 tw-text-[var(x--sed-black-60-color)]"
              >days</span
            >
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class TimeTrackingHeaderDsComponent {
  @Input()
  offWork = 0;

  @Input()
  restricted = 0;
}
